import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './password.types';
import * as constants from './password.constants';

export const passwordReducer = generateResourceReducer<types.IPassword>({
  STORE: constants.STORE_PASSWORD,
  CLEAR: constants.CLEAR_PASSWORD,
});
